import React, { SetStateAction, Dispatch } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';

interface IProps {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  warningStatement: string;
  tag: string;
  action: (id?: string | undefined) => void;
}

const DeleteModal = ({
  showModal,
  setShowModal,
  warningStatement,
  tag,
  action,
}: IProps): JSX.Element => {
  const toggle = () => setShowModal(!showModal);

  return (
    <Dialog
      open={showModal}
      onOpenChange={(open) => {
        if (!open) toggle();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete {tag}</DialogTitle>
        </DialogHeader>
        <div>{warningStatement}</div>
        <DialogFooter>
          <div>
            <Button onClick={toggle} variant="secondary">
              Cancel
            </Button>
            <Button variant="destructive" onClick={() => action()}>
              Delete {tag}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
